/**
 * Copy for the booking sheet, taken from the iOS tour flow (TourFlow feature)
 * with the web-specific variants the 1-pager calls out. Keep strings here so
 * design review has one place to diff against the Figma mocks.
 */
export const TOUR_SHEET_COPY = {
  sheetTitle: 'Book a self tour',
  slot: {
    heading: 'Schedule your self tour',
    subheading: 'Pick a time that works for you. Tours take about 30 minutes.',
    noSelection: 'No time selected',
    duration: (minutes: number) => `About ${minutes} minutes, self-guided`,
    booked: 'Booked',
    continue: 'Continue',
  },
  login: {
    heading: 'Sign in to book your tour',
    body: 'Sign in or create an account to pick up where you left off.',
    continue: 'Continue',
  },
  phone: {
    heading: 'What’s your phone number?',
    body: 'We’ll text your access code to this number before your tour.',
    label: 'Mobile number',
    save: 'Continue',
    saveFailed: 'We couldn’t save your number. Please try again.',
  },
  confirmation: {
    heading: 'Use the Opendoor app to get in',
    bodyLead: { mobile: 'Download', desktop: 'Scan to get' },
    body: ' the Opendoor app and verify your identity. We’ll text your access code before your tour.',
    scanPill: 'Scan with your phone',
    appStore: { label: 'Download on the App Store', kicker: 'Download on the', name: 'App Store' },
    googlePlay: { label: 'Get it on Google Play', kicker: 'GET IT ON', name: 'Google Play' },
  },
  error: {
    heading: 'Something went wrong',
    body: 'We couldn’t book your tour. Please try again in a few minutes or contact support.',
    supportHeading: 'Customer support',
    hours: 'Mon–Fri, 10 AM–7 PM ET',
    phoneDisplay: '(844) 961-2722',
    phoneHref: 'tel:+18449612722',
    email: 'support@opendoor.com',
    emailHref: 'mailto:support@opendoor.com',
    retry: 'Try again',
  },
} as const;
